import React from 'react';

function UserProfile() {
	return <div>User Profile page</div>;
}

export default UserProfile;
